import { Controller } from "@hotwired/stimulus"

// Add to Sale controller - handles new/existing sale option toggle
export default class extends Controller {
  static targets = ["newFields", "existingFields"]

  toggleOption(event) {
    const isNew = event.target.value === "new"

    if (this.hasNewFieldsTarget) {
      this.newFieldsTarget.classList.toggle("hidden", !isNew)
    }

    if (this.hasExistingFieldsTarget) {
      this.existingFieldsTarget.classList.toggle("hidden", isNew)
    }
  }
}
